import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CommonDialogService } from '@core/common-dialog/common-dialog.service';
import { TranslationService } from '@core/services/translation.service';
import { BaseComponent } from 'src/app/base.component';
import { ToastrService } from 'ngx-toastr';
import { GrpserviceService } from '../grpservice.service';
import { AddEditMarkerDialogComponent } from './add-edit-marker-dialog/add-edit-marker-dialog.component';

@Component({
  selector: 'app-marker-grp',
  templateUrl: './marker-grp.component.html',
  styleUrls: ['./marker-grp.component.scss'],
})
export class MarkerGrpComponent extends BaseComponent implements OnInit {
  displayedColumns: string[] = [
    'action',
    'marqueeText',
    'linkText',
    'createdBy',
    'createdOn',
    'approvedBy',
    'approvedDate',
    'approvedStatus',
  ];

  dataSource = new MatTableDataSource<any>([]);
  totalCount = 0;
  pageSize = 10;
  loading = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private commonDialogService: CommonDialogService,
    private toastrService: ToastrService,
    private newsService: GrpserviceService,
    public translationService: TranslationService
  ) {
    super(translationService);
    this.getLangDir();
  }

  ngOnInit(): void {
    this.GetMarqueeList(1, this.pageSize);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  // Updated component method to pass request object to service
  GetMarqueeList(pageNumber: number, pageSize: number): void {
    this.loading = true;
    const request: any = {
      pageNumber,
      pageSize,
      searchText: '', // You can add a search input later if needed
    };

    this.newsService.GetMarqueeList(request).subscribe({
      next: (res: any) => {
        // Update to match your API response structure
        this.dataSource.data = res.data?.items || [];
        this.totalCount = res.data?.totalRecords || 0;
        this.loading = false;
      },
      error: () => {
        this.toastrService.error('Failed to load marquee.');
        this.loading = false;
      },
    });
  }

  // ✅ Paginator Event
  onPageChange(event: any): void {
    this.GetMarqueeList(event.pageIndex + 1, event.pageSize);
  }

  openAddEditDialog(marquee?: any): void {
    const dialogRef = this.dialog.open(AddEditMarkerDialogComponent, {
      width: '600px',
      direction: this.langDir,
      data: { marquee }, // ✅ you are passing marquee
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.GetMarqueeList(
          this.paginator.pageIndex + 1,
          this.paginator.pageSize
        );
      }
    });
  }

  deleteMarquee(marquee: any): void {
    this.commonDialogService
      .deleteConformationDialog(`Are you sure you want to delete?`)
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          const payload: any = {
            Id: marquee.id, // ✅ match backend casing
            MarqueeText: marquee.marqueeText,
            LinkText: marquee.linkText,
            CreatedBy: null, // API expects these fields
            UpdatedBy: null,
            ApprovedBy: null,
            ApprovedDate: null,
            ApprovedStatus: null,
            Action: 'DELETE', // ✅ tells API it's delete
          };

          this.newsService.ManageMarqueeRecord(payload).subscribe({
            next: () => {
              this.toastrService.success('Marquee deleted successfully.');
              this.GetMarqueeList(
                this.paginator.pageIndex + 1,
                this.paginator.pageSize
              );
            },
            error: () => {
              this.toastrService.error('Failed to delete marquee.');
            },
          });
        }
      });
  }
}
